module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.774c05cc.ttf";